// const appUrl = process.env.REACT_APP_API_URL;
const appUrl = "https://api.cablinks.org";
// const appUrl = "https://api-stage.cablinks.org";

const ApiConfig = {
  // =========EndPoints==========
  login: "login",
  download: "export/data",
  profileView: "profile",
  getEmployeeList: "employeelist/",
  getTimesheetList: "timesheet/",
  getEmployeeTimesheetList: "timesheets/",
  getProjectList: "project",
  getEmpLeave: "leaveemp",
  getEmployeeDetails: "get-employee/",
  imageUrl: "uploadImages",
  getTaxType: "tax-type",
  imagesUpload: "images",
  addNewEmployee: "add-employee",
  getCountry: "codes/",
  signUp: "register",
  verifyEmail: "verify-email",
  resendVerificationEmail: "resend-verification-email",
  sendPhoneOtp: "send-phone-otp",
  verifyPhoneOtp: "verify-phone-otp",
  company: "company",
  createPayroll: "payroll",
  industry: "industry",
  getAttendance: "attendances/",
  deleteEmployee: "delete-employee/",
  deleteAttendance: "attendance/",
  deleteTimesheet: "timesheet/",
  deletePayroll: "payroll/",
  quote: "quote",
  payrollStats: "payroll/stats",
  allStats: "all_stats",
  checkInHoliday: "check-holiday",
  timesheet: "timesheet/",
  timesheetUpdate: "timesheet",
  checkOut: "checkout/",
  timesheetRequest: "timesheet-status",
  setPermission: "permission/",
  getEmployeePermission: "permission/",
  updatePayroll: "payroll/",
  updateIncreament: "increment/",
  handleBonus: "bonus",
  handleLeaveRequest: "leaves/",
  updateRecruitment: "recruitment/",
  getleaveManagement: "getleave/",
  geLeaveBalance: "getleavebalance",
  getRecruitment: "recruitments/",
  getSingleRecruitment: "recruitment/",
  getLeaveType: "leave-type",
  getLeaveSetting: "leave-settings",
  handleLeaveSetting: "leave-setting",
  handleDeleteLeave: "leave",
  getCommission: "commissions",
  getTravelAllowance: "travel_allowance",
  handleCommissionRequest: "commission-status/",
  handleTravelAllowancesRequest: "travel-allowance-status/",
  applyLeaveRequest: "apply-leave/",
  applyCommission: "commission",
  applayTravelAllowances: "travel_allowance",
  addRecruitment: "recruitment",
  profile: "company",
  IsCheckin: "ischeckin",
  closeRecruitment: "close-recruitment/",
  getPayrollList: "payrolls/",
  getPayroll: "payroll/",
  getRolesAndPermissions: "permission",
  accountSetting: "company",
  updateOvertime: "overtime/",
  updateAddition: "addition/",
  updateDeduction: "deduction/",
  updatePay: "salary/transaction/",
  getSalary: "salary",
  getSalaryView: "salaries",
  updateSalary: "salary/",
  salaryStats: "salary/stats",
  updateProcess: "process/",
  printALL: "salary_print",
  emailAll: "email_all",
  project: "project",
  projectAdmin: "projects",
  accountLeaveType: "leave-type",
  accountPayslipShow: "showon_payslip",
  accountPayslipShowEmptyValues: "showon_payslip_empty_values",
  holiday: "holiday",
  holidayType: "holiday_type",
  attendanceExport: "attendance/exportMultiple",
  attendanceImport: "attendance/import",
  getLoans: "loans",
  getLoansTranasaction: "loan_transaction",
  getDeductionTranasaction: "deduction_transaction",
  handleLoan: "loan",
  getLoanPayslip: "loan_transaction/",
  handleEmployeeReport: "employee_report",
  handlePayslipReport: "payslip_report",
  handleEmpPayslipReport: "emppayslip_report",
  handleFringeReport: "fringe_report",
  handleCreditReport: "credit_report",
  handleLeviesReport: "levies_report",
  handlePensionReport: "pension_report",
  handlePayeReport: "tax_report",
  handleGeneralizeTax: 'generalize_tax_report',
  handleUifReport: "uif_report",
  handleDeductionReport: "deduction_report",
  handleSalaryReport: "salary_print",
  handleAttendanceReport: "attendance_report",
  handleSdlReport: "sdl_report",
  getDeduction: "deductions",
  handleDeduction: "deduction",
  sentInvoice: "invoice/sent",
  paidInvoice: "invoice/paid",
  handlePayrollDepartment: "employee_department",
  payrollPayslip: "salary/info/",
  getPayrollPayslip: "payroll_info/",
  getLeavePayslip: "get_leave",
  handleLeave: "employee-appleave/",
  handleLoanPayslip: "loan_trans/",
  getItemList: "items",
  deleteItem: "item",
  getAllBanks: "banks",
  getOneBank: "bank",
  getSuppliers: "suppliers",
  handleSupplier: "supplier",
  downloadBill: "bill/download",
  billPaid: "bill/paid",
  getAllBill: 'bills/supplier',
  downloadInvoice: "invoice/download",
  getCustomers: "customers",
  getStatementGenerate: "statement",
  handleCustomer: "customer",
  getInvoice: "invoices",
  handleInvoice: "invoice",
  getPurchase: "purchases",
  handlePurchase: "purchase",
  unitType: "units",
  handleUnit: "unit",
  defaultBank: "bank/default",
  getSales: "sales",
  handleSales: "sale",
  getInvoiceView: "invoice/view",
  getBill: "bills",
  getBillView: "bill/view",
  sendBill: "bill/send",
  handleBill: "bill",
  getPension: "pension_trans/",
  getAllowance: "allowance_trans/",
  getLevie: "levie_trans/",
  getFringe: "fringe_balance/",
  getSchedule: "schedule",
  allowanceType: "allowance_type",
  taxTable: "tax-table",
  fringeType: "fringe_type",
  leviesType: "levies_type",
  pensionType: "pension_type",
  taxType: "tax-periods",
  handleTaxType: "tax-period",
  loanType: "loan_type",
  deductionType: "deduction_type",
  getPayslipSetting: "payslip_settings",
  handlePayslipSetting: "payslip_setting",
  settings: "settings",
  empAllowances: "emp_allowance",
  empPension: "emp_pensions",
  empPensionsingle: "emp_pension",
  handleEmpPension: "emp_pension",
  handleContributions: "emp_contribution",
  handleEmpMedical: "medical",
  getMedical: "medicals",
  getContributions: "emp_contribution",
  handleDepartment: "department",
  operator: "operator",
  operatorEmployees: "all_operators_emp",
  deleteCommission: "commission",
  deleteTravelAllowances: "travel_allowance",
  getPayslipTaxyear: "payslip_taxyear",
  handleTransfer: "account/transfer",
  getTaxyear: "payslip_year",
  handlePensionType: "pension_type",
  handleTaxYear: "tax-year",
  getTaxYear: "tax-years",
  getStartPeriod: "tax-period",
  empFringeBenefits: "emp_fringe",
  empLevie: "emp_levies",
  handleLevie: "emp_levie",
  removeAllowance: "emp_allowance/remove",
  removeContribution: "emp_contribution/remove",
  removeFringeBenefit: "emp_fringe/remove",
  removeLevy: "emp_levies/remove",
  payslipSetting: "payslip_settings",
  getAllDepartmentList: "all_departments",
  getCompanyList: "companies",
  markAbsent: "mark_absent",
  companyDetails: "company_details",
  payslipFormat: "payslip/formats",
  payslipTransaction: "payslip_transaction",
  createAllowance: "admin/allowance_type",
  DeletefringeType: "admin/fringe_type",
  DeletepensionType: "admin/pension_type",
  deleteLeave: "leave-setting",
  uifGet: "uif-tables",
  uifDelete: "uif-table",
  sdlGet: "sdl-tables",
  sdlDelete: "sdl-table",
  createSdl: "sdl-table",
  createUif: "uif-table",
  contributionsType: "contribution_type",
  udateCommission: "commission/",
  updateTravelAllowances: "travel_allowance/",
  leviesTypes: "levies_type",
  contribution: "contribution_type",
  updateContribution: "contribution_type",
  deleteContribution: "contribution_type",
  countrySelection: "admin/country_selection/",
  selectedCountries: "admin/country_selection",
  getcontribution: "contribution_trans/",
  deleteTextTabels: "tax-table",
  deleteAllTextTabels: "delete-multiple",
  salaryInfo: "salary/info/",
  addPayroll: "payroll/add",
  taxPeriod: "tax-periods",
  yearTaxTable: "tax-table",
  approveAllCommission: "all-commission-status",
  approveAllTravelAllowance: "all-travel-allowance-status",
  deleteCompany: "deletecompany",
  addTaxPeriod: "tax-period",
  purchase: "purchase/",
  leaveBalanceRate: "leave_balance_rate",
  manageLeaveBalance: "leave-balance/manage",
  addLeaveRate: "leave_balance_rate",
  employeeLeavesBalance: "employee_leaves_balance",
  employeeLeavesBalances: "employee_leaves_balances",
  addTaxLabel: "tax_label",
  getAllTaxLabel: "tax_labels",
  deleteTaxLabel: "tax_labels",
  addTaxRule: "tax_rule",
  getTaxRule: "tax_rules",
  deleteTaxRule: "tax_rule",
  deleteTaxRules: "tax_rules",
  updateTaxRUle: "tax_rule",
  getCashFlow: "cash_flow",
  getSuppliersPurchase: "suppliers_purchases",
  deletePurchase: "purchase",
  cashFlowDownload: "cash_flow_pdf",
  getProfitLoss: "profit_loss",
  getStatementDownload: "bank/download",
  getExpenseType: "exp_inc_types",
  getOtherExpenses: "other_expenses",
  createExpenses: "other_expenses",
  updateExpense: "other_expenses",
  deleteExpense: "other_expenses",
  addOtherIncome: "other_income",
  getOtherIncome: "other_income",
  updateOtherIncome: "other_income",
  deleteIncome: "other_income",
  addSpecialItem: "special_item",
  downloadCashReceipt: "receipt/download",
  getReceiptView: "receipt/view",
  handleSentReceipt: "receipt/send",
  addCompanyBankAccount: "companyBankAccount",
  getCompanyBankAccounts: "companyBankAccounts",
  getCashAccount: "cashAccount",
  addAccountTransaction: "accountTransaction",
  addStatementTransaction: "uploadBankStatement",
  getAccountTransactions: "accountTransactions",
  updateUncategorisedTransaction: "categorizeTransaction",
  getAccountTransactionsByDateRange: "accountTransactions/dateRange",
  addAccountReconciliation: "accountReconciliation",
  getAccountReconciliations: "accountReconciliations",
  finalizeAccountReconciliation: "accountReconciliation/finalize",
  undoAccountReconciliation: "accountReconciliation/undo",
  getAccountReconciliationDetails: "accountReconciliationDetails",
  deleteAccountReconiliation: "accountReconciliation",
  getAllQuotesData: "quotes",
  deleteQuote: "quote",
  getQuoteView: 'quote/view',
  downloadQuote: 'quote/download',
  sendQuote: 'quote/publish',
  getAllRecurringInvoiceTemplates: "recurringInvoices",
  deleteRecurringInvoiceTemplate: "recurringInvoice",
  getRecurringInvoiceTemplateDetail: "recurringInvoice",
  updateRecurringInvoiceTemplate: "recurringInvoice",
  getAllTransactionData: 'invoice',
  createCreditNote: 'creditNote',
  getAllCreditNotes: 'creditNotes',
  getCreditNote: 'creditNote',
  updateCreditNote: 'creditNote',
  deleteCreditNote: 'creditNote',
  viewCreditNote: 'creditNote/view',
  downloadCreditNote: 'creditNote/download',
  getNotesReceiptView: "creditNote/view",
  downloadNotesReceipt: 'creditNote/download',
  noteCreate: 'creditNote',
  invoiceList: 'invoices/customer',
  sendNote: "creditNote/send",
  salesOrder: "salesOrders",
  salesOrderView: 'salesOrder/view',
  salesOrderDownload: 'salesOrder/download',
  salesOrderSend: 'salesOrder/send',
  deleteSalesOrder: 'salesOrder',
  createSalesOrder: 'salesOrder',
  fullfillComplete: 'fulfill/complete',
  allPurchaseOrders: 'purchaseOrders',
  createPurchaseOrder: 'purchaseOrder',
  getPurchaseOrderView: 'purchaseOrder/view',
  handlePurchaseOrderDownload: 'purchaseOrder/download',
  sendPurchaseOrder: 'purchaseOrder/send',
  handleDeletePurchaseOrder: 'purchaseOrder',
  markReceive: 'purchaseOrder',
  handleGetSupplier: 'supplier',
  ageGroup: 'age-group',
  getCreditTypes: 'credit_type',
  addEmployeeCredits: 'credit',
  getEmployeeCredits: 'credit/employee',
  deleteEmployeeCredits: 'credit',
  getCreditById: 'credit',
  getAllCredits: 'credits',
  handleAssest: 'assets',
  handleCreate: 'asset',
  taxTableImport: 'tax-table/upload',
  handleWorkerDataExport: 'export-profile',
  deleteCredit: 'credit',
  deductionDownload: 'export/deductions/pdf',
  dedutionTransactionDownload: 'export/deduction-transactions/pdf',
  loanDownLoad: 'export/loans/pdf',
  loanTransactionDownload: 'export/loan-transactions/pdf',
  leaveDownload: 'export/leaves/pdf',
  handleLoanReport: 'loan_report',
  createTravelAllowance: 'travel-allowance-rate',
  getAllCredit: "employee_credit_types",
  getBeneficieries: 'credit_beneficiaries/by-credit-type',
  createCredits: "credit_beneficiary",
  updateCredits: "credit_beneficiaries",
  deleteCredits: "credit_beneficiary/",
  handleCreditApply: "employee_credit",
  createBenificiary: "credit_beneficiary",
  getSingleData: 'employee_credits',
  getEmployeeTaxRulesAvailable: 'employee/tax-rules',
  handleEmployeeTaxRules: 'employee/tax-rules',
  leavePdf: 'leave_pdf',
  reportMenu: 'superadmin/report-menu',
  updateLeaveRequest: 'leaves',
  travelClaimRequest: 'travel_allowance/defaults',
  rebate: 'rebate',
  rebateThreshold: 'rebate-threshold',
  plan: "plan",
  topup: "topup",
  subscription: "subscription",
  subscriptionSummary: "subscription/stats",
  deductionManualPayment: "deduction/manual-payment",
  loanManualPayment: "loan/manual-payment",
  employeeSectionReport: "employee_section_report/",
  getAdminContributionsType: "admin/contribution_type",
  leaveTypeForAdmin: 'admin_leave_type',
  getAdminLeaveTypes: 'admin_leave_types',
  pendingUpdates: "pending-updates",
  pendingUpdatesHistory: "pending-updates/history",
  notification: "notification",
  notificationUnreadCount: "notification/unread-count",
  notificationMarkAllRead: "notification/mark-all-read",
  notificationAdmin: "notification/admin",

  baseUrl: `${appUrl}/admin/`,
  baseApi: `${appUrl}/`,
};

export { ApiConfig };
export default ApiConfig;
